export default {
  isUSA: state => state.isUSA,
};
